module.exports = __webpack_public_path__ + "images/125_640.jpg";